var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/common/zod-ko.ts
import { INTL_LOCALE } from "@inflip/shared";
import { z, ZodIssueCode } from "zod";
var num = /* @__PURE__ */ __name((v, lang) => Number(v).toLocaleString(INTL_LOCALE[lang]), "num");
var ZOD_MESSAGES = {
  ko: {
    required: "\uD544\uC218 \uD56D\uBAA9\uC774\uC5D0\uC694.",
    invalidType: "\uC785\uB825 \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.",
    stringRequired: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.",
    stringMin: /* @__PURE__ */ __name((n) => `${n}\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.`, "stringMin"),
    arrayMin: /* @__PURE__ */ __name((n) => `${n}\uAC1C \uC774\uC0C1 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694.`, "arrayMin"),
    numberMin: /* @__PURE__ */ __name((n) => `${num(n, "ko")} \uC774\uC0C1\uC774\uC5B4\uC57C \uD574\uC694.`, "numberMin"),
    numberGt: /* @__PURE__ */ __name((n) => `${num(n, "ko")}\uBCF4\uB2E4 \uCEE4\uC57C \uD574\uC694.`, "numberGt"),
    tooSmall: "\uAC12\uC774 \uB108\uBB34 \uC791\uC544\uC694.",
    stringMax: /* @__PURE__ */ __name((n) => `${n}\uC790 \uC774\uD558\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`, "stringMax"),
    arrayMax: /* @__PURE__ */ __name((n) => `${n}\uAC1C\uAE4C\uC9C0 \uC120\uD0DD\uD560 \uC218 \uC788\uC5B4\uC694.`, "arrayMax"),
    numberMax: /* @__PURE__ */ __name((n) => `${num(n, "ko")} \uC774\uD558\uC5EC\uC57C \uD574\uC694.`, "numberMax"),
    numberLt: /* @__PURE__ */ __name((n) => `${num(n, "ko")}\uBCF4\uB2E4 \uC791\uC544\uC57C \uD574\uC694.`, "numberLt"),
    tooBig: "\uAC12\uC774 \uB108\uBB34 \uCEE4\uC694.",
    email: "\uC774\uBA54\uC77C \uD615\uC2DD\uC774 \uC544\uB2C8\uC5D0\uC694.",
    url: "\uC8FC\uC18C(URL) \uD615\uC2DD\uC774 \uC544\uB2C8\uC5D0\uC694.",
    date: "\uB0A0\uC9DC \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.",
    invalidChoice: "\uC120\uD0DD\uD560 \uC218 \uC5C6\uB294 \uAC12\uC774\uC5D0\uC694.",
    invalidDate: "\uB0A0\uC9DC\uAC00 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694.",
    unknownKeys: "\uC54C \uC218 \uC5C6\uB294 \uD56D\uBAA9\uC774 \uD3EC\uD568\uB3FC \uC788\uC5B4\uC694.",
    multipleOf: /* @__PURE__ */ __name((n) => `${String(n)} \uB2E8\uC704\uB85C \uC785\uB825\uD574 \uC8FC\uC138\uC694.`, "multipleOf"),
    invalid: "\uC785\uB825\uAC12\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC544\uC694."
  },
  en: {
    required: "This field is required.",
    invalidType: "The format is invalid.",
    stringRequired: "Please enter a value.",
    stringMin: /* @__PURE__ */ __name((n) => `Please enter at least ${num(n, "en")} characters.`, "stringMin"),
    arrayMin: /* @__PURE__ */ __name((n) => `Please select at least ${num(n, "en")}.`, "arrayMin"),
    numberMin: /* @__PURE__ */ __name((n) => `Must be ${num(n, "en")} or more.`, "numberMin"),
    numberGt: /* @__PURE__ */ __name((n) => `Must be greater than ${num(n, "en")}.`, "numberGt"),
    tooSmall: "The value is too small.",
    stringMax: /* @__PURE__ */ __name((n) => `Please enter ${num(n, "en")} characters or fewer.`, "stringMax"),
    arrayMax: /* @__PURE__ */ __name((n) => `You can select up to ${num(n, "en")}.`, "arrayMax"),
    numberMax: /* @__PURE__ */ __name((n) => `Must be ${num(n, "en")} or less.`, "numberMax"),
    numberLt: /* @__PURE__ */ __name((n) => `Must be less than ${num(n, "en")}.`, "numberLt"),
    tooBig: "The value is too large.",
    email: "This is not a valid email address.",
    url: "This is not a valid URL.",
    date: "The date format is invalid.",
    invalidChoice: "This value can't be selected.",
    invalidDate: "The date is invalid.",
    unknownKeys: "Contains unknown fields.",
    multipleOf: /* @__PURE__ */ __name((n) => `Please enter in steps of ${num(n, "en")}.`, "multipleOf"),
    invalid: "The value is invalid."
  },
  ja: {
    required: "\u5FC5\u9808\u9805\u76EE\u3067\u3059\u3002",
    invalidType: "\u5165\u529B\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    stringRequired: "\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    stringMin: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u6587\u5B57\u4EE5\u4E0A\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "stringMin"),
    arrayMin: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u500B\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "arrayMin"),
    numberMin: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u4EE5\u4E0A\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "numberMin"),
    numberGt: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u3088\u308A\u5927\u304D\u304F\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "numberGt"),
    tooSmall: "\u5024\u304C\u5C0F\u3055\u3059\u304E\u307E\u3059\u3002",
    stringMax: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "stringMax"),
    arrayMax: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u500B\u307E\u3067\u9078\u629E\u3067\u304D\u307E\u3059\u3002`, "arrayMax"),
    numberMax: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u4EE5\u4E0B\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "numberMax"),
    numberLt: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u3088\u308A\u5C0F\u3055\u304F\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "numberLt"),
    tooBig: "\u5024\u304C\u5927\u304D\u3059\u304E\u307E\u3059\u3002",
    email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5F62\u5F0F\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    url: "URL\u306E\u5F62\u5F0F\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    date: "\u65E5\u4ED8\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    invalidChoice: "\u9078\u629E\u3067\u304D\u306A\u3044\u5024\u3067\u3059\u3002",
    invalidDate: "\u65E5\u4ED8\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    unknownKeys: "\u4E0D\u660E\u306A\u9805\u76EE\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059\u3002",
    multipleOf: /* @__PURE__ */ __name((n) => `${num(n, "ja")}\u5358\u4F4D\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002`, "multipleOf"),
    invalid: "\u5165\u529B\u5024\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002"
  }
};
function zodErrorMap(lang) {
  const m = ZOD_MESSAGES[lang];
  return (issue) => {
    switch (issue.code) {
      case ZodIssueCode.invalid_type:
        if (issue.received === "undefined" || issue.received === "null") return {
          message: m.required
        };
        return {
          message: m.invalidType
        };
      case ZodIssueCode.too_small:
        if (issue.type === "string") return {
          message: issue.minimum === 1 ? m.stringRequired : m.stringMin(issue.minimum)
        };
        if (issue.type === "array") return {
          message: m.arrayMin(issue.minimum)
        };
        if (issue.type === "number" || issue.type === "bigint") return {
          message: issue.inclusive ? m.numberMin(issue.minimum) : m.numberGt(issue.minimum)
        };
        return {
          message: m.tooSmall
        };
      case ZodIssueCode.too_big:
        if (issue.type === "string") return {
          message: m.stringMax(issue.maximum)
        };
        if (issue.type === "array") return {
          message: m.arrayMax(issue.maximum)
        };
        if (issue.type === "number" || issue.type === "bigint") return {
          message: issue.inclusive ? m.numberMax(issue.maximum) : m.numberLt(issue.maximum)
        };
        return {
          message: m.tooBig
        };
      case ZodIssueCode.invalid_string:
        if (issue.validation === "email") return {
          message: m.email
        };
        if (issue.validation === "url") return {
          message: m.url
        };
        if (issue.validation === "datetime" || issue.validation === "date") return {
          message: m.date
        };
        return {
          message: m.invalidType
        };
      case ZodIssueCode.invalid_enum_value:
      case ZodIssueCode.invalid_literal:
      case ZodIssueCode.invalid_union:
      case ZodIssueCode.invalid_union_discriminator:
        return {
          message: m.invalidChoice
        };
      case ZodIssueCode.invalid_date:
        return {
          message: m.invalidDate
        };
      case ZodIssueCode.unrecognized_keys:
        return {
          message: m.unknownKeys
        };
      case ZodIssueCode.not_multiple_of:
        return {
          message: m.multipleOf(issue.multipleOf)
        };
      default:
        return {
          message: m.invalid
        };
    }
  };
}
__name(zodErrorMap, "zodErrorMap");
z.setErrorMap(zodErrorMap("ko"));

// src/common/pagination.schema.ts
import { isValidDateOnly, PAGINATION } from "@inflip/shared";
import { z as z2 } from "zod";
var pageQuerySchema = z2.object({
  page: z2.coerce.number().int().min(1).default(PAGINATION.DEFAULT_PAGE),
  pageSize: z2.coerce.number().int().min(1).max(PAGINATION.MAX_PAGE_SIZE).default(PAGINATION.DEFAULT_PAGE_SIZE)
});
var pageResponseSchema = /* @__PURE__ */ __name((item) => z2.object({
  items: z2.array(item),
  total: z2.number().int(),
  page: z2.number().int(),
  pageSize: z2.number().int(),
  totalPages: z2.number().int()
}), "pageResponseSchema");
var dateOnly = z2.string().regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD").refine(isValidDateOnly, "\uC5C6\uB294 \uB0A0\uC9DC\uC608\uC694");
var dateRangeQuerySchema = z2.object({
  dateFrom: dateOnly.optional(),
  dateTo: dateOnly.optional()
});

// src/common/note-items.schema.ts
import { joinNoteItems, MAX_NOTE_ITEM_LENGTH, MAX_NOTE_ITEMS, noteItemsOf } from "@inflip/shared";
import { z as z3 } from "zod";
var noteItemsTextSchema = /* @__PURE__ */ __name((maxLength) => z3.string().max(maxLength).superRefine((text, ctx) => {
  const items = noteItemsOf(text);
  if (items.length > MAX_NOTE_ITEMS) {
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: `\uD56D\uBAA9\uC740 ${MAX_NOTE_ITEMS}\uAC1C\uAE4C\uC9C0 \uC801\uC744 \uC218 \uC788\uC5B4\uC694.`
    });
  }
  if (items.some((item) => item.length > MAX_NOTE_ITEM_LENGTH)) {
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: `\uD55C \uD56D\uBAA9\uC740 ${MAX_NOTE_ITEM_LENGTH}\uC790\uAE4C\uC9C0 \uC801\uC744 \uC218 \uC788\uC5B4\uC694.`
    });
  }
}).transform((text) => joinNoteItems(noteItemsOf(text)) || void 0), "noteItemsTextSchema");

// src/common/responses.schema.ts
import { z as z4 } from "zod";
var okResponseSchema = z4.object({
  ok: z4.literal(true)
});
var apiErrorResponseSchema = z4.object({
  statusCode: z4.number().int(),
  code: z4.string().optional(),
  message: z4.string()
});
var healthResponseSchema = z4.object({
  status: z4.literal("ok"),
  service: z4.string(),
  ts: z4.string().datetime()
});
function sentAsReceived(schema) {
  return schema.brand();
}
__name(sentAsReceived, "sentAsReceived");

// src/common/offer-terms-rows.schema.ts
import { z as z5 } from "zod";
var offerTermRowSchema = z5.object({
  /** 언어와 무관한 줄 이름 (예: 'purpose', 'duration') — 화면이 줄을 고를 때. 없는 줄도 있다 */
  key: z5.string().optional(),
  label: z5.string(),
  value: z5.string()
});
var offerTermsRowsSchema = z5.object({
  rows: z5.array(offerTermRowSchema),
  groups: z5.array(z5.object({
    title: z5.string(),
    rows: z5.array(offerTermRowSchema)
  }))
});

// src/common/purchase-options.schema.ts
import { AppearanceMode } from "@inflip/shared";
import { z as z6 } from "zod";
var purchaseOptionSetSchema = z6.object({
  title: z6.string(),
  included: z6.array(z6.string()),
  addons: z6.array(z6.object({
    group: z6.enum([
      "assets",
      "placements",
      "legalUses",
      "channels",
      "merchandiseChannels",
      "adultUsage"
    ]),
    key: z6.string(),
    label: z6.string(),
    amount: z6.number().int()
  })),
  excluded: z6.array(z6.string()),
  addonHint: z6.string().nullable(),
  monthly: z6.boolean()
});
var offerPurchaseOptionsSchema = z6.object({
  /** 출연권이 아닌 권리 — 고를 범위가 없으면 null */
  options: purchaseOptionSetSchema.nullable(),
  /** 출연권 방식별 촬영물 공개 범위 — recording 이 열렸을 때만 보인다 */
  appearance: z6.array(z6.object({
    mode: z6.nativeEnum(AppearanceMode),
    options: purchaseOptionSetSchema.nullable(),
    recording: z6.object({
      kind: z6.enum([
        "PACKAGES_PUBLIC",
        "PACKAGES_ALL",
        "FIXED"
      ]),
      allowed: z6.boolean(),
      label: z6.string().nullable()
    })
  }))
});

// src/common/order-actor.schema.ts
import { z as z7 } from "zod";
var orderTransitionActorSchema = z7.enum([
  "USER",
  "ADMIN",
  "SYSTEM"
]);

export {
  __name,
  ZOD_MESSAGES,
  zodErrorMap,
  pageQuerySchema,
  pageResponseSchema,
  dateRangeQuerySchema,
  noteItemsTextSchema,
  okResponseSchema,
  apiErrorResponseSchema,
  healthResponseSchema,
  sentAsReceived,
  offerTermRowSchema,
  offerTermsRowsSchema,
  purchaseOptionSetSchema,
  offerPurchaseOptionsSchema,
  orderTransitionActorSchema
};
//# sourceMappingURL=chunk-LBZDZW6L.js.map